// extracted by mini-css-extract-plugin
export var actionIndicator = "StockTransferItem-module--actionIndicator--sDdTc";
export var commentIcon = "StockTransferItem-module--commentIcon--zTl7j";
export var commentIndicator = "StockTransferItem-module--commentIndicator--QPHGJ";
export var icon = "StockTransferItem-module--icon--FwKEB";
export var iconIncoming = "StockTransferItem-module--iconIncoming--WGF-z";
export var status = "StockTransferItem-module--status--nLptp";
export var statusDot = "StockTransferItem-module--statusDot--M9xio";